import React from 'react';

interface TotalsSummaryProps {
  totals?: {
    subtotal?: number;
    vat?: number;
    withheldIVA?: number;
    perceivedIVA?: number;
    incomeWithholding?: number;
    globalDiscountNonTaxable?: number;
    globalDiscountExempt?: number;
    globalDiscountTaxable?: number;
    nonTaxableSales?: number;
    exemptSales?: number;
    totalOperationAmount?: number;
    totalNonAffectingAmounts?: number;
    totalToPay?: number;
  };
  title?: string;
}

const formatMoney = (value: number | null | undefined): string =>
  typeof value === 'number' ? `$${value.toFixed(2)}` : '$0.00';

const DocumentTotalsSummary: React.FC<TotalsSummaryProps> = ({ totals, title = 'Totales' }) => {
  const summaryItems = [
    ['Sub Total', totals?.subtotal],
    ['IVA (13%)', totals?.vat],
    ['IVA Retenido', totals?.withheldIVA],
    ['IVA Percibido', totals?.perceivedIVA],
    ['Retención Renta', totals?.incomeWithholding],
    ['Desc. Global No Sujeto', totals?.globalDiscountNonTaxable],
    ['Desc. Global Exento', totals?.globalDiscountExempt],
    ['Desc. Global Gravado', totals?.globalDiscountTaxable],
    ['Venta No Sujeta', totals?.nonTaxableSales],
    ['Venta Exenta', totals?.exemptSales],
    ['Monto Total de la Operación', totals?.totalOperationAmount],
    ['Montos No Afectos', totals?.totalNonAffectingAmounts],
  ];

  return (
    <div className="mt-6 p-4">
      <h3 className="mb-4 text-lg font-semibold text-black dark:text-white">{title}</h3>
      <div className="grid grid-cols-2 gap-y-2 gap-x-8 text-sm text-gray-700 dark:text-gray-300">
        {summaryItems.map(([label, value]) => (
          <React.Fragment key={label as string}>
            <span className="font-medium">{label}:</span>
            <span className="text-right font-semibold text-black dark:text-white">
              {formatMoney(value as number)}
            </span>
          </React.Fragment>
        ))}
      </div>

      <div className="mt-4 flex justify-between border-t border-stroke pt-3 text-base font-bold text-black dark:border-strokedark dark:text-white">
        <span>Total a Pagar:</span>
        <span>{formatMoney(totals?.totalToPay)}</span>
      </div>
    </div>
  );
};

export default DocumentTotalsSummary;
